export const AppConfig = {
  name: 'Desko',
  appId: 'makeroz',
  channel: 'web',
  appVersion: '1.0.0',

  hkUrl: 'https://deskomake.com/',
  cnUrl: 'https://www.desktopspace.cn/',
}
